module.exports = __webpack_public_path__ + "img/乌镇隆源路街区2.1f8d7b21.jpg";